import { IonIcon } from "@ionic/react";
import {
  sunnyOutline,
  moonOutline,
  listOutline,
  analyticsOutline,
} from "ionicons/icons";
import { nightModeStyle } from "../publicFunctions/publicHelpers/helpers";

function SimpleToggle({
  toggleMode,
  nightMode,
  hideWhenMenuClicked = false,
  horizontal = false,
  use = "nightDay",
  optionASelected,
}) {
  let optionA;
  let optionB;
  if (use === "nightDay") {
    optionA = moonOutline;
    optionB = sunnyOutline;
  } else if (use === "listTournament") {
    optionA = listOutline;
    optionB = analyticsOutline;
  } else {
    return null;
  }

  if (hideWhenMenuClicked) {
    return null;
  }
  return (
    <div
      style={nightMode ? nightModeStyle : {}}
      className={
        "width-fit-content cursor--pointer day-night-toggle" +
        (nightMode ? " white-border" : "") +
        (horizontal ? " flex--direction-row" : " flex--direction-column") +
        (!optionASelected
          ? !horizontal
            ? " column-reverse"
            : " row-reverse"
          : "")
      }
      onClick={() => {
        toggleMode(!optionASelected);
      }}
    >
      <IonIcon
        className="social-icon"
        icon={optionASelected ? optionA : optionB}
      />
      <div className={"circle-icon" + (nightMode ? " white-border" : "")}></div>
    </div>
  );
}

export default SimpleToggle;
